<div class="container-fluid">
  <app-page-header-breadcrumb [pageTitle]="pageTitle" [breadcrumbList]="breadcrumbList">
  </app-page-header-breadcrumb>
  <div class="card">
    <div class="card-body">

    </div>
  </div>
</div>